module.exports = __webpack_public_path__ + "img/e-commerce-white.7e534e86.png";